import { Input } from "antd";
import { useEffect, useState } from "react";
import { deleteEmbedForm, postEmbedForm } from "../../Services/API";
import { cdnUrl } from "../constant/constant";
import DeleteConfirmationModal from "../Custom/Modals/DeleteConfirmationModal";
import { WidgetConfigProps } from "../EmbeddingForm/types";
import { getEmbeddingCode, icons, widgetConfigDetailsDefault, getEmbeddingCodeReactHtml, getEmbeddingCodeReactJs, getEmbeddingCodeAngularJs } from "./constant";
import './style.scss';
import { ContentScreenDeleteIcon } from "../Custom/Buttons/ButtonIcons";
import { globalColors } from "../../Utils/colors";
import CodePopup from "./codePopup";
import { HeaderContainer } from "../ContentCard/styled";
import embedPlusIcon from "../../assets/embedPlusIcon.svg"
import { OutlinedButton } from "../Custom/Buttons";

interface EmbeddingSideTabProps {
  widgetConfigDetails: WidgetConfigProps;
  setWidgetConfigDetails: React.Dispatch<React.SetStateAction<WidgetConfigProps>>;
  formId: string;
  editUUID: string;
  selectedEmbed: any;
  setSelectedEmbed: any;
  embedResponse: any;
  fetchEmbed: any;
  shareMode: boolean;
}

const EmbeddingSideTab: React.FC<EmbeddingSideTabProps> = ({ widgetConfigDetails, formId, editUUID, setWidgetConfigDetails, selectedEmbed, setSelectedEmbed, embedResponse, fetchEmbed, shareMode }) => {
  const [deletePopup, setDeletePopup] = useState<boolean>(false);
  const [embedLinkPopup, setEmbedLinkPopup] = useState<boolean>(false);
  const [instruction, setInstruction] = useState<string>("HTML")

  const handleNewEmbed = async () => {
    try {
      await postEmbedForm(editUUID, widgetConfigDetailsDefault);
      fetchEmbed();
    } catch (error) {
      console.error("Error posting embed API error:", error);
    }
  };

 
  const handleDeleteEmbed = async (_id: string) => {
    try {
      await deleteEmbedForm(editUUID, _id);
      fetchEmbed();
    } catch (error) {
      console.error("Error deleting embed API error:", error);
    }
    setDeletePopup(false);
  };

  const handleClick = (values: any) => {
    setSelectedEmbed(values);
    const id = values._id;
    const config = values.config;
    setWidgetConfigDetails({ ...config, id });
  };

  const handleEmbedClick = (values: any) => {
    setSelectedEmbed(values);
    setWidgetConfigDetails(values.config);
    setEmbedLinkPopup(true);
  };

  const handleDeleteButton = (values: any) => {
    setSelectedEmbed(values);
    setWidgetConfigDetails(values.config);
    setDeletePopup(true);
  };

  useEffect(() => {
    fetchEmbed();
  }, []);

  useEffect(() => {
    setSelectedEmbed((prev: any) => ({
      ...prev,
      config: {
        ...widgetConfigDetails,
        name: prev?.config?.name
      }
    }));
  }, [widgetConfigDetails]);

  useEffect(() => {
    if (shareMode && embedResponse.length > 0 && !selectedEmbed?._id) {
      const firstEmbed = embedResponse[0];
      setSelectedEmbed(firstEmbed);
      setWidgetConfigDetails({ ...firstEmbed.config, id: firstEmbed._id });
    }
  }, [shareMode]
  )
  return (
    <div className="leftSideTab">
      <div className="embedHistory">
        <div className="embedConstant">
          <HeaderContainer className="embedNameLabel">Embed Name</HeaderContainer>
          <div className="changes">
            <Input
              className="embedInput"
              type="text"
              placeholder="Enter Embedding name..."
              value={selectedEmbed?.config?.name || ""}
              onChange={(e) => {
                if (selectedEmbed) {
                  setSelectedEmbed({
                    ...selectedEmbed,
                    config: {
                      ...selectedEmbed.config,
                      name: e.target.value
                    }
                  });
                }
              }}
            />
          </div>
          <OutlinedButton
            backgroundColor={globalColors.primary}
            className="addNewEmbedButton"
            onClick={handleNewEmbed}
            startIcon={<img src={embedPlusIcon} alt="embedPlusIcon" style={{ width: "25px", height: "23px" }} />}
            variant="outlined"
            size="large"
          >
            New Embed
          </OutlinedButton>
        </div>
        <div className="EmbedDisplay">
          {embedResponse.map((values: any) => (
            <div
              className={`EmbedButtons ${selectedEmbed._id === values._id ? "active" : ""}`}
              onClick={() => handleClick(values)}
              key={values._id}
            >
              <div
                className="embedName"
                style={{
                  borderWidth: selectedEmbed._id === values._id ? 3 : 1,
                  borderColor: "#000"
                }}
              >
                <div className={`icon-container ${selectedEmbed._id === values._id ? "active" : ""}`}>
                  <img src={icons[values.config.mode]} alt={values.config.mode} />
                </div>
                <div className="embedNameButton">{values.config.name}</div>
              </div>
              <div className="action-button-container">
                <img
                  className={`action-icon ${selectedEmbed._id === values._id ? "active" : ""}`}
                  onClick={() => handleEmbedClick(values)}
                  src={icons["embedCopy"]}
                  alt="embedcopy"
                />

                <ContentScreenDeleteIcon
                  color={selectedEmbed._id === values._id ? globalColors.white : globalColors.primary}
                  disabled={false}
                  key={values._id}
                  onClick={() => handleDeleteButton(values)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <DeleteConfirmationModal
        isOpen={deletePopup}
        cancelHandler={() => setDeletePopup(false)}
        submitHandler={() => handleDeleteEmbed(selectedEmbed._id)}
        cancelText="Cancel"
        submitText="Delete"
        contentText="Are you sure that you want to delete this Form?"
      />

      {embedLinkPopup && (instruction === "React") && (
        <CodePopup

          closeIcon={icons["close"]}
          onCloseClick={() => {
            setEmbedLinkPopup(false);
          }}
          instruction={instruction}
          setInstruction={setInstruction}
          codeSnippet={getEmbeddingCodeReactHtml(formId, selectedEmbed?._id)}
          codeSnippet1={getEmbeddingCodeReactJs(cdnUrl)}
        />

      )}
      {embedLinkPopup && (instruction === "Angular") && (
        // <div>
        <CodePopup
          closeIcon={icons["close"]}
          onCloseClick={() => {
            setEmbedLinkPopup(false);
          }}
          instruction={instruction}
          setInstruction={setInstruction}
          codeSnippet={getEmbeddingCodeReactHtml(formId, selectedEmbed?._id)}
          codeSnippet1={getEmbeddingCodeAngularJs(cdnUrl)}
        />

      )}
      {embedLinkPopup && (instruction === "HTML" || instruction === "WordPress") && (
        <CodePopup
          closeIcon={icons["close"]}
          onCloseClick={() => {
            setEmbedLinkPopup(false);
          }}
          instruction={instruction}
          setInstruction={setInstruction}
          codeSnippet={getEmbeddingCode(formId, selectedEmbed?._id, cdnUrl)}
          codeSnippet1=""
        />
      )}
    </div>
  );
};

export default EmbeddingSideTab;